import { authorizeGroupRole, User } from 'features/user'
import { UserGroup } from 'features/user/types/UserGroupRoles'
import { Can } from '../Can'
import { onAbTestsAccess } from './features/abTests'
import {
  onAdUnitAccess,
  onAdUnitCreateUpdateDelete,
  onAdUnitFieldsRead,
  onAdUnitUnfilledRecoveryReadPrebidSettingsWarning,
} from './features/adUnit'
import {
  onDomainAccess,
  onDomainCustomBranchAlertRead,
  onDomainRichPlacementsFeatureMultiAnchorAdUnitConnectionRead,
  onDomainRichPlacementsMultiAnchorAccess,
  onDomainUnfilledRecoveryBaseAdUnitPathRead,
  onDomainUnfilledRecoveryReadPrebidSettingsWarning,
} from './features/domain'
import { onFinanceAccess, onFinanceAdminOptionReadUpdate } from './features/finance'
import { onGlobalSetupAmazonAccess } from './features/globalSetup/amazon'
import {
  onGlobalSetupAccess,
  onGlobalSetupPriceGeniusRead,
  onGlobalSetupWorkspaceUpdate,
} from './features/globalSetup/common'
import {
  onGlobalSetupDefaultsPrebidStackAccess,
  onGlobalSetupDefaultsRichPlacementsAccess,
} from './features/globalSetup/defaults'
import { onGlobalSetupGoogleAdManagerConnectionAccess } from './features/globalSetup/googleAccountManagerConnection'
import {
  onGlobalSetupPrebidBiddersAccess,
  onGlobalSetupPrebidModuleAccess,
  onGlobalSetupPrebidModulesInventoryConnectionParamsOwnRead,
  onGlobalSetupPrebidProtectionAccess,
} from './features/globalSetup/prebid'
import { onGlobalSetupSupplyChainAccess } from './features/globalSetup/supplyChain'
import { onHistoryAccess } from './features/history'
import { onLayoutAccess } from './features/layout'
import { onPageAccess } from './features/page'
import { onPerformanceAccess, onPerformanceAdminOptionReadUpdate } from './features/performance'
import { onPortalAccess } from './features/portal'
import { onProductAccess, onProductStatusReadUpdate, onProductUpdate } from './features/product'
import { onTagAccess } from './features/tag'
import { onUserAccess } from './features/user'
import { onWorkspaceAccess } from './features/workspace'

export const userByGroup = (user: User, can: Can) => {
  const userBelongsToGroup = (userGroup: UserGroup) => authorizeGroupRole(userGroup, user.role)

  if (userBelongsToGroup('everyone')) {
    onAbTestsAccess(can)
    onAdUnitAccess(can)
    onDomainAccess(can)
    onDomainRichPlacementsMultiAnchorAccess(can)
    onGlobalSetupAccess(can)
    onGlobalSetupAmazonAccess(can)
    onGlobalSetupDefaultsPrebidStackAccess(can)
    onGlobalSetupDefaultsRichPlacementsAccess(can)
    onGlobalSetupGoogleAdManagerConnectionAccess(can)
    onGlobalSetupPrebidBiddersAccess(can)
    onGlobalSetupPrebidModuleAccess(can)
    onGlobalSetupPrebidModulesInventoryConnectionParamsOwnRead(can)
    onGlobalSetupPrebidProtectionAccess(can)
    onGlobalSetupSupplyChainAccess(can)
    onHistoryAccess(can)
    onLayoutAccess(can)
    onPageAccess(can)
    onPerformanceAccess(can)
    onPortalAccess(can)
    onProductAccess(can)
    onTagAccess(can)
  }

  if (userBelongsToGroup('employeesOnly')) {
    onAdUnitCreateUpdateDelete(can)
    onAdUnitFieldsRead(can)
    onAdUnitUnfilledRecoveryReadPrebidSettingsWarning(can)
    onDomainCustomBranchAlertRead(can)
    onDomainRichPlacementsFeatureMultiAnchorAdUnitConnectionRead(can)
    onDomainUnfilledRecoveryBaseAdUnitPathRead(can)
    onDomainUnfilledRecoveryReadPrebidSettingsWarning(can)
    onFinanceAccess(can)
    onFinanceAdminOptionReadUpdate(can)
    onGlobalSetupPriceGeniusRead(can)
    onGlobalSetupWorkspaceUpdate(can)
    onPerformanceAdminOptionReadUpdate(can)
    onProductStatusReadUpdate(can)
    onProductUpdate(can)
    onUserAccess(can)
    onWorkspaceAccess(can)
  }
}
